import { DetectionType } from '@hakimo-ui/hakimo/types';
import {
  correctDetectionOptions,
  incorrectDetectionOptions,
  incorrectDetectionV2Options,
  personDetectedOptions,
  vehicleDetectedOptions,
} from '@hakimo-ui/hakimo/util';
import { Selectable } from '@hakimo-ui/shared/ui-base';

const commentOptionsMap = {
  [DetectionType.PERSON]: personDetectedOptions,
  [DetectionType.VEHICLE]: vehicleDetectedOptions,
  [DetectionType.INCORRECT_DETECTION]: incorrectDetectionOptions,
  [DetectionType.CORRECT_DETECTION]: correctDetectionOptions,
  [DetectionType.INCORRECT_DETECTION_V2]: incorrectDetectionV2Options,
};

export const getStatusCommentOptions = (
  detectionType: DetectionType
): Selectable[] => {
  const options = commentOptionsMap[detectionType];
  return options.map((item) => ({ id: String(item), name: item }));
};

export const getCommentPrefix = (type?: DetectionType) => {
  switch (type) {
    case DetectionType.PERSON:
      return 'Person Present';
    case DetectionType.VEHICLE:
      return 'Moving Vehicle';
    case DetectionType.INCORRECT_DETECTION:
      return 'False Positive';
    case DetectionType.CORRECT_DETECTION:
      return 'Correct Detection';
    case DetectionType.INCORRECT_DETECTION_V2:
      return 'Incorrect Detection';
    default:
      return '';
  }
};
